import type { VariantProps } from 'class-variance-authority'
import { Check, X } from 'lucide-react'

import { cn } from '@/lib/utils'
import {
  statusBadgeIconVariants,
  statusBadgeVariants,
} from '@/shared/components/status-badge-variants'

const statusBadgeLabels = {
  active: 'Active',
  inactive: 'Inactive',
} as const

type StatusBadgeProps = VariantProps<typeof statusBadgeVariants> & {
  className?: string
}

export const StatusBadge = ({ status = 'active', className }: StatusBadgeProps) => {
  const resolvedStatus = status ?? 'active'
  const Icon = resolvedStatus === 'active' ? Check : X

  return (
    <span className={cn(statusBadgeVariants({ status: resolvedStatus }), className)}>
      <span
        aria-hidden
        className={statusBadgeIconVariants({ status: resolvedStatus })}
      >
        <Icon className="size-4 stroke-3" />
      </span>
      {statusBadgeLabels[resolvedStatus]}
    </span>
  )
}

export { type StatusBadgeProps }
